var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:_vm.$style['minus-button'],attrs:{"type":_vm.buttonTypes.OPACITY}},[_c('img',{attrs:{"src":require("../../assets/img/global/global__minus.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }